var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inset-32 content" },
    [
      _c("p", { staticClass: "fs7 insety-8" }, [
        _vm._v(_vm._s(_vm.$t("capital_para_1"))),
      ]),
      _c("p", { staticClass: "fs7 insety-8 content-oblique" }, [
        _vm._v(_vm._s(_vm.$t("all_in_millions"))),
      ]),
      _c(
        "ib-table-basic",
        {
          ref: "table",
          staticClass: "ib-row shrink fs7 fg70 event-border",
          attrs: {
            data: _vm.netCapitalList,
            spacing: "huge",
            height: "400px",
            wrap: "",
            rowstripe: "",
            rowborder: "",
            colborder: "",
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function (row) {
                return [
                  _c("td", [_c("span", [_vm._v(_vm._s(row.month_year))])]),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(row.total_equity) + " ")]),
                  ]),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(row.tentative_net_capital))]),
                  ]),
                  _c("td", [_c("span", [_vm._v(_vm._s(row.net_capital))])]),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(row.excess_net_capital))]),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "10ch" } },
            [_vm._v(_vm._s(_vm.$t("month_end")))]
          ),
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "10ch" } },
            [_vm._v(_vm._s(_vm.$t("total_equity")))]
          ),
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "10ch" } },
            [_vm._v(_vm._s(_vm.$t("adj_net_capital")))]
          ),
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "10ch" } },
            [_vm._v(_vm._s(_vm.$t("net_capital")))]
          ),
          _c(
            "ib-table-col",
            { staticClass: "event-header-border", attrs: { width: "10ch" } },
            [_vm._v(_vm._s(_vm.$t("exc_net_capital")))]
          ),
        ],
        1
      ),
      _c("hr", { staticClass: "before-32" }),
      _c(
        "div",
        { staticClass: "insety-16" },
        [
          _c(
            "ib-button",
            {
              attrs: { tone: "sell", appearance: "link" },
              on: { click: _vm.getURLFocusFilingData },
            },
            [
              _vm._v(" " + _vm._s(_vm.$t("capital_focus_link")) + " "),
              _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                _c("path", {
                  attrs: { d: "M15 4l7 7-7 7v-4C3 14 2 19 2 19S3 8 15 8z" },
                }),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }